import { Component, OnInit } from '@angular/core';
import { BasePageComponent } from '@carm/_utils/base-page.component';

@Component({
  selector: 'carm-api-download-terms',
  templateUrl: './api-download-terms.component.html',
  styleUrls: ['./api-download-terms.component.scss']
})
export class ApiDownloadTermsComponent extends BasePageComponent implements OnInit {

  public termsAndApendix = this.translateService.instant('components.confirmTermsDialog.apiDownload');

  constructor() {
    super();
  }

  ngOnInit(): void {
  }
}
